import axiosInstance from "../../../helpers/api";

export const getAllHomeworks = (id) => {
  return axiosInstance.get(`/superadmin/homeworks?course_id=${id}`);
};

export const getStudentHomeworkQuiz = () => {
  return axiosInstance.get("/admin/exams/homework_quiz");
};

export const editHomeworks = (formData) => {
  return axiosInstance.post(
    `/superadmin/homeworks/${formData.id}`,
    formData.formData
  );
};

export const createHomeworks = (formData) => {
  return axiosInstance.post("/superadmin/homeworks", formData);
};

export const deleteHomework = (id) => {
  return axiosInstance.delete(`/superadmin/homeworks/${id}`);
};

export const filterHomework = (id) => {
  return axiosInstance.get(`/admin/homeworks/group/${id}`);
};
